export const MANUAL_PAYMENT = 1;
export const COMPUTER_CHECK = 2;
export const CREDIT_CARD = 3;
export const ACH = 4;
export const E_PAYMENT = 5;
